import _classCallCheck from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

import { __awaiter } from "tslib";
import { makeRequest } from '@finam/txservices-core/request';
import { Status, Code } from '@finam/txservices-core/proto';
import logger, { getDateString } from './logger';
import { decodeBase64, deserializeSession as _deserializeSession, parseToken } from './utils';
import { ConfirmationType } from './types';
import { RenewRequest, SessionContext, TxAuthApiClient, TFAParams, TFAChannel } from './proto';
import { SubscribeRenewRequest, TxAuthClientClient } from './client/proto';
var EPS_UNARY = 60 * 1000; // 1m

var EPS_STREAM = 15 * 1000; // 15s

var RANDOM_RATE = 10 * 1000; // 10s

var TokenProvider = /*#__PURE__*/function () {
  function TokenProvider(options) {
    var _this = this;

    _classCallCheck(this, TokenProvider);

    this.timeDelta = 0;
    this.tokenChangeListeners = [];
    this.renewFailed = false;
    this.waitingStreamRenew = false;

    this.handleRenewTimeout = function (prevToken) {
      if (_this.onRenewTimeout && prevToken === _this.token) {
        _this.onRenewTimeout();
      }
    };

    this.getDevice = options.getDevice;
    this.onRenew = options.onRenew;
    this.onRenewFailed = options.onRenewFailed;
    this.onRenewTimeout = options.onRenewTimeout;
    this.onNotConfirmed = options.onNotConfirmed;
    this.hosts = options.hosts;
    this.tokenScope = options.tokenScope;
    this.setTokenReceiveTime = options.setTokenReceiveTime;
    this.renewMethodType = options.renewMethodType;
  }

  _createClass(TokenProvider, [{
    key: "retrieveFirebase",
    value: function retrieveFirebase() {
      var parsedToken = this.getParsedToken();
      return parsedToken.firebase;
    }
  }, {
    key: "retrieveProvider",
    value: function retrieveProvider() {
      var parsedToken = this.getParsedToken();
      return parsedToken.provider;
    }
  }, {
    key: "retrieveConfirmationResponse",
    value: function retrieveConfirmationResponse() {
      var tfa = this.deserializeTFA();
      var deedline = tfa === null || tfa === void 0 ? void 0 : tfa.deadlineAfter;
      var channel = tfa === null || tfa === void 0 ? void 0 : tfa.channel;
      var tfaType;

      switch (channel) {
        case TFAChannel.SMS:
          tfaType = ConfirmationType.SMS;
          break;

        case TFAChannel.EMAIL:
          tfaType = ConfirmationType.EMAIL;
          break;

        case TFAChannel.PUSH:
          tfaType = ConfirmationType.PUSH;
          break;

        case TFAChannel.TOTP:
          tfaType = ConfirmationType.TOTP;
          break;

        default:
          tfaType = undefined;
      }

      return {
        enable: !!tfa,
        timeout: deedline && Number(deedline.seconds) * 1000,
        codeNumber: tfa === null || tfa === void 0 ? void 0 : tfa.number,
        codeLength: tfa === null || tfa === void 0 ? void 0 : tfa.length,
        type: tfaType,
        addresses: tfa === null || tfa === void 0 ? void 0 : tfa.address
      };
    }
  }, {
    key: "getToken",
    value: function getToken() {
      return this.token;
    }
  }, {
    key: "getParsedToken",
    value: function getParsedToken() {
      if (!this.parsedToken) {
        throw new Error('no parsed token');
      }

      return this.parsedToken;
    }
  }, {
    key: "setToken",
    value: function setToken(token, receivedTime) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var tokenPrev, createdTime, expireOn, logoutOn;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                logger.log("".concat(getDateString(), " set token"));
                tokenPrev = this.token;
                this.token = token;
                this.renewFailed = false;
                this.parsedToken = parseToken(token);
                this.receiveTime = receivedTime;
                createdTime = this.getCreatedTime();

                if (receivedTime != null && createdTime && !Number.isNaN(createdTime)) {
                  this.timeDelta = createdTime - receivedTime;
                } else {
                  this.timeDelta = 0;
                }

                logger.log("".concat(getDateString(), " token created on"), new Date(createdTime).toLocaleString());

                if (tokenPrev && tokenPrev !== token) {
                  this.tokenChangeListeners.forEach(function (cb) {
                    return cb(token);
                  });

                  if (this.onRenew != null) {
                    this.onRenew(this.buildResponse());
                  }

                  logger.log("".concat(getDateString(), " onRenew call"), token);
                }

                expireOn = new Date(Date.now() + this.getTokenRenewAfter());
                logoutOn = new Date(Date.now() + this.getLogoutAfter());
                logger.warn("".concat(getDateString(), " token expired on _").concat(expireOn.toLocaleString(), "_ (valid until _").concat(logoutOn.toLocaleString(), "_)"));

                if (!this.isTokenConfirmed()) {
                  _context.next = 18;
                  break;
                }

                this.startExpireTimeout();

                if (!(this.renewMethodType === 'stream')) {
                  _context.next = 18;
                  break;
                }

                _context.next = 18;
                return this.startRenewSubscription();

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "setTokenScope",
    value: function setTokenScope(tokenScope) {
      this.tokenScope = tokenScope;
    }
  }, {
    key: "deserializeSession",
    value: function deserializeSession() {
      return _deserializeSession(this.getParsedToken());
    }
  }, {
    key: "deserializeSessionContext",
    value: function deserializeSessionContext() {
      var _this$getParsedToken = this.getParsedToken(),
          scontext = _this$getParsedToken.scontext;

      var bytes = decodeBase64(scontext);
      return SessionContext.fromBinary(bytes);
    }
  }, {
    key: "deserializeTFA",
    value: function deserializeTFA() {
      var _this$getParsedToken2 = this.getParsedToken(),
          tfa = _this$getParsedToken2.tfa;

      if (!tfa) {
        return undefined;
      }

      var bytes = decodeBase64(tfa);
      return TFAParams.fromBinary(bytes);
    }
  }, {
    key: "getPersonId",
    value: function getPersonId() {
      var _a;

      return (_a = this.deserializeSession().person) === null || _a === void 0 ? void 0 : _a.id;
    }
  }, {
    key: "removeToken",
    value: function removeToken() {
      var _a;

      if (this.parsedToken) {
        if (this.isTokenExpired()) {
          (_a = this.renewStreamPromise) === null || _a === void 0 ? void 0 : _a.catch(function () {});
          this.rejectRenewTokenPromise(new Error('expired token is removed'));
        } else {
          this.resolveRenewTokenPromise();
        }
      }

      this.token = undefined;
      this.parsedToken = undefined;
      this.renewFailed = false;
      this.tokenChangeListeners = [];
    }
  }, {
    key: "getFreshTokenSync",
    value: function getFreshTokenSync() {
      try {
        if (!this.isTokenExpired()) {
          return this.token;
        }
      } catch (err) {
        return undefined;
      }

      return undefined;
    }
  }, {
    key: "getFreshToken",
    value: function getFreshToken() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var token;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                logger.log("".concat(getDateString(), " get fresh token call"));
                _context2.next = 3;
                return this.renew();

              case 3:
                token = _context2.sent;
                return _context2.abrupt("return", token.token);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "renew",
    value: function renew() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                logger.log("".concat(getDateString(), " renew call"));

                if (this.isTokenConfirmed()) {
                  _context3.next = 5;
                  break;
                }

                this.handleNotConfirmedToken();
                _context3.next = 7;
                break;

              case 5:
                _context3.next = 7;
                return this.handleTokenRenew();

              case 7:
                return _context3.abrupt("return", this.buildResponse());

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "handleTokenRenew",
    value: function handleTokenRenew() {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var tokenNew;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!this.isTokenRenewExpired()) {
                  _context4.next = 4;
                  break;
                }

                this.handleTokenRenewExpired();
                _context4.next = 21;
                break;

              case 4:
                if (!(force || this.isTokenExpired())) {
                  _context4.next = 21;
                  break;
                }

                if (this.token) {
                  _context4.next = 7;
                  break;
                }

                throw new Error('no token for renew');

              case 7:
                if (!(!force && this.renewFailed)) {
                  _context4.next = 9;
                  break;
                }

                return _context4.abrupt("return");

              case 9:
                _context4.t0 = this.renewMethodType;
                _context4.next = _context4.t0 === 'unary' ? 12 : _context4.t0 === 'stream' ? 17 : 20;
                break;

              case 12:
                _context4.next = 14;
                return this.requestRenew(this.token, force);

              case 14:
                tokenNew = _context4.sent;
                this.setToken(tokenNew, Date.now());
                return _context4.abrupt("break", 21);

              case 17:
                _context4.next = 19;
                return this.startRenewSubscription(true, force);

              case 19:
                return _context4.abrupt("break", 21);

              case 20:
                return _context4.abrupt("break", 21);

              case 21:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "handleTokenRenewExpired",
    value: function handleTokenRenewExpired() {
      var error = Status.create({
        code: Code.UNAUTHENTICATED,
        message: 'Token renew expired!'
      });
      this.onRenewFailed && this.onRenewFailed(error);
      logger.log('token renew expired');
      throw error;
    }
  }, {
    key: "handleNotConfirmedToken",
    value: function handleNotConfirmedToken() {
      this.onNotConfirmed && this.onNotConfirmed();
      logger.log('token is not confirmed');
    }
  }, {
    key: "listenTokenChange",
    value: function listenTokenChange(listener) {
      var _this2 = this;

      this.tokenChangeListeners.push(listener);
      return function () {
        var index = _this2.tokenChangeListeners.indexOf(listener);

        if (index >= 0) {
          _this2.tokenChangeListeners.splice(index, 1);
        }
      };
    }
  }, {
    key: "buildResponse",
    value: function buildResponse() {
      return {
        token: this.token,
        session: this.deserializeSession(),
        sessionContext: this.deserializeSessionContext(),
        firebase: this.retrieveFirebase(),
        provider: this.retrieveProvider(),
        confirmation: this.retrieveConfirmationResponse(),
        created: this.getCreatedTime(),
        renewExp: this.getRenewExpiration(),
        receiveTime: this.receiveTime
      };
    }
  }, {
    key: "isTokenExpired",
    value: function isTokenExpired() {
      var after = this.getTokenRenewAfter();
      return after <= 0;
    }
  }, {
    key: "isTokenRenewExpired",
    value: function isTokenRenewExpired() {
      var after = this.getLogoutAfter();
      return after <= 0;
    }
  }, {
    key: "isTokenConfirmed",
    value: function isTokenConfirmed() {
      return !this.getParsedToken().tfa;
    }
  }, {
    key: "getRenewMethodType",
    value: function getRenewMethodType() {
      return this.renewMethodType;
    }
  }, {
    key: "getRenewExpiration",
    value: function getRenewExpiration() {
      var parsedToken = this.getParsedToken();
      var renewExp = parsedToken.renewExp;
      return parseInt(renewExp, 10) * 1000;
    }
  }, {
    key: "getCreatedTime",
    value: function getCreatedTime() {
      var parsedToken = this.getParsedToken();
      var created = parsedToken.created;
      return parseInt(created, 10) * 1000;
    }
  }, {
    key: "getTimeEps",
    value: function getTimeEps() {
      return this.renewMethodType === 'stream' ? EPS_STREAM : EPS_UNARY;
    }
  }, {
    key: "getTimeDelta",
    value: function getTimeDelta() {
      return this.timeDelta;
    }
  }, {
    key: "getLogoutAfter",
    value: function getLogoutAfter() {
      var renewExp = this.getRenewExpiration();
      var current = Date.now() + this.getTimeDelta();
      return Math.floor(renewExp - current);
    }
  }, {
    key: "requestRenew",
    value: function requestRenew(token) {
      var _this3 = this;

      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this.renewRequestPromise) {
        return this.renewRequestPromise;
      }

      this.renewRequestPromise = new Promise(function (resolve, reject) {
        return __awaiter(_this3, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
          var body, renewTimeoutId, request, res;
          return _regeneratorRuntime().wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  body = RenewRequest.create({
                    device: this.getDevice(),
                    token: token,
                    force: force
                  });
                  renewTimeoutId = setTimeout(this.handleRenewTimeout, 2000, token);
                  request = makeRequest({
                    hosts: this.hosts
                  });
                  _context5.prev = 3;
                  _context5.next = 6;
                  return request.unary({
                    log: 'TokenProvider:renew',
                    handler: function handler(transport, logRequest) {
                      logRequest(body);
                      return new TxAuthApiClient(transport).renew(body);
                    }
                  });

                case 6:
                  res = _context5.sent;
                  logger.log("".concat(getDateString(), " renew successful!"));
                  clearTimeout(renewTimeoutId);

                  if (this.setTokenReceiveTime) {
                    this.setTokenReceiveTime(Date.now());
                  }

                  resolve(res.token);
                  this.renewRequestPromise = undefined;
                  _context5.next = 23;
                  break;

                case 14:
                  _context5.prev = 14;
                  _context5.t0 = _context5["catch"](3);
                  logger.error("".concat(getDateString(), " renew failed!"));
                  logger.error(_context5.t0);
                  clearTimeout(renewTimeoutId);

                  if (this.onRenewFailed && token === this.token) {
                    this.onRenewFailed(_context5.t0);
                  }

                  this.renewFailed = true;
                  this.renewRequestPromise = undefined;
                  reject(_context5.t0);

                case 23:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5, this, [[3, 14]]);
        }));
      });
      return this.renewRequestPromise;
    }
  }, {
    key: "subscribeRenew",
    value: function subscribeRenew(token) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var subscribeRenewRequest = SubscribeRenewRequest.create({
        device: this.getDevice(),
        token: token,
        tokenScope: this.tokenScope,
        force: force
      });
      var request = makeRequest({
        hosts: this.hosts
      });
      return request.stream({
        keepAlive: true,
        log: 'TokenProvider:subscribeRenew',
        handler: function handler(transport, logRequest) {
          logRequest(subscribeRenewRequest);
          return new TxAuthClientClient(transport).subscribeRenew(subscribeRenewRequest);
        }
      });
    }
  }, {
    key: "getTokenRenewAfter",
    value: function getTokenRenewAfter() {
      var parsedToken = this.getParsedToken();
      var exp = parsedToken.exp,
          renewExp = parsedToken.renewExp;
      var current = Date.now() + this.getTimeEps() + this.getTimeDelta();
      var expires = parseInt(exp, 10) * 1000;
      var renewExpires = parseInt(renewExp, 10) * 1000;
      return Math.floor(Math.min(expires, renewExpires) - current);
    }
  }, {
    key: "startExpireTimeout",
    value: function startExpireTimeout() {
      var _this4 = this;

      var timeout = this.getTokenRenewAfter();
      var random = Math.random() * RANDOM_RATE;

      if (this.expireTimeoutId != null) {
        clearTimeout(this.expireTimeoutId);
      }

      this.expireTimeoutId = setTimeout(function () {
        return __awaiter(_this4, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
          return _regeneratorRuntime().wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  _context6.prev = 0;
                  _context6.next = 3;
                  return this.handleTokenRenew();

                case 3:
                  _context6.next = 7;
                  break;

                case 5:
                  _context6.prev = 5;
                  _context6.t0 = _context6["catch"](0);

                case 7:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6, this, [[0, 5]]);
        }));
      }, timeout + random);
    }
  }, {
    key: "createRenewTokenReadyPromise",
    value: function createRenewTokenReadyPromise() {
      var _this5 = this;

      return new Promise(function (resolve, reject) {
        _this5.resolveRenewTokenReady = resolve;
        _this5.rejectRenewTokenReady = reject;
      });
    }
  }, {
    key: "resolveRenewTokenPromise",
    value: function resolveRenewTokenPromise() {
      if (this.resolveRenewTokenReady) {
        this.resolveRenewTokenReady();
        this.resolveRenewTokenReady = undefined;
      }

      this.renewStreamPromise = undefined;
    }
  }, {
    key: "rejectRenewTokenPromise",
    value: function rejectRenewTokenPromise(error) {
      if (this.rejectRenewTokenReady) {
        this.rejectRenewTokenReady(error);
        this.rejectRenewTokenReady = undefined;
      }

      this.renewStreamPromise = undefined;
    }
  }, {
    key: "startRenewSubscription",
    value: function startRenewSubscription(resubscribe, force) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _this6 = this;

        var renewPromise, tokenExpired, renewTimeoutId;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!(this.renewSubscription && !resubscribe)) {
                  _context7.next = 2;
                  break;
                }

                return _context7.abrupt("return");

              case 2:
                if (!(this.renewStreamPromise && resubscribe && this.waitingStreamRenew && !force)) {
                  _context7.next = 6;
                  break;
                }

                _context7.next = 5;
                return this.renewStreamPromise;

              case 5:
                return _context7.abrupt("return");

              case 6:
                if (this.token) {
                  _context7.next = 8;
                  break;
                }

                throw new Error('no token for renew subscribe');

              case 8:
                renewPromise = this.renewStreamPromise || this.createRenewTokenReadyPromise();

                if (!this.isTokenRenewExpired()) {
                  _context7.next = 20;
                  break;
                }

                _context7.prev = 10;
                this.handleTokenRenewExpired();
                _context7.next = 19;
                break;

              case 14:
                _context7.prev = 14;
                _context7.t0 = _context7["catch"](10);
                // заворачиваем ошибку в общий промис,
                // чтобы висящий промис разрешился и все его слушатели получили данную ошибку
                this.rejectRenewTokenPromise(_context7.t0);
                _context7.next = 19;
                return renewPromise;

              case 19:
                return _context7.abrupt("return");

              case 20:
                tokenExpired = this.isTokenExpired();

                if (this.renewSubscription) {
                  this.renewSubscription.unsubscribe();
                }

                this.waitingStreamRenew = tokenExpired || resubscribe || false;
                renewTimeoutId = tokenExpired ? setTimeout(this.handleRenewTimeout, 2000, this.token) : undefined;
                this.renewStreamPromise = renewPromise;
                this.renewSubscription = this.subscribeRenew(this.token, force).subscribe(function (data) {
                  logger.log("".concat(getDateString(), " subscribe renew successful!"));
                  renewTimeoutId && clearTimeout(renewTimeoutId);
                  var receiveTime = Date.now();

                  if (_this6.setTokenReceiveTime) {
                    _this6.setTokenReceiveTime(receiveTime);
                  }

                  _this6.setToken(data.token, receiveTime);

                  _this6.resolveRenewTokenPromise();

                  _this6.waitingStreamRenew = false;
                }, function (error) {
                  logger.error("".concat(getDateString(), " subscribe renew failed!"), error);
                  renewTimeoutId && clearTimeout(renewTimeoutId);
                  _this6.onRenewFailed && _this6.onRenewFailed(error);
                  _this6.renewFailed = true;

                  _this6.rejectRenewTokenPromise(error);

                  _this6.waitingStreamRenew = false;
                });

                if (!(resubscribe || tokenExpired)) {
                  _context7.next = 31;
                  break;
                }

                _context7.next = 29;
                return renewPromise;

              case 29:
                _context7.next = 32;
                break;

              case 31:
                renewPromise.catch(function () {});

              case 32:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[10, 14]]);
      }));
    }
  }, {
    key: "stopRenew",
    value: function stopRenew() {
      if (this.expireTimeoutId != null) {
        logger.log("".concat(getDateString(), " renew stopped"));
        clearTimeout(this.expireTimeoutId);
        this.expireTimeoutId = undefined;
      }

      if (this.renewMethodType === 'stream' && this.renewSubscription) {
        logger.log("".concat(getDateString(), " subscribe renew stopped"));
        this.renewSubscription.unsubscribe();
        this.renewSubscription = null;
        this.waitingStreamRenew = false;
      }
    }
  }, {
    key: "resumeRenew",
    value: function resumeRenew() {
      if (this.parsedToken && this.isTokenConfirmed()) {
        if (this.expireTimeoutId == null) {
          logger.log("".concat(getDateString(), " renew resumed"));
          this.startExpireTimeout();
        }

        if (this.renewMethodType === 'stream' && this.renewSubscription == null) {
          logger.log("".concat(getDateString(), " subscribe renew resumed"));
          this.startRenewSubscription().catch(function (e) {
            logger.error("".concat(getDateString(), " start renew subscription failed!"), e);
          });
        }
      }
    }
  }, {
    key: "forceRenew",
    value: function forceRenew() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                logger.log("".concat(getDateString(), " force token renew"));
                this.stopRenew();
                _context8.next = 4;
                return this.handleTokenRenew(true);

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));
    }
  }], [{
    key: "build",
    value: function build(getDevice, hosts, renewMethodType, onRenew, onRenewFailed, onRenewTimeout, onNotConfirmed, tokenScope, setTokenReceiveTime) {
      return new TokenProvider({
        getDevice: getDevice,
        onRenew: onRenew,
        onRenewFailed: onRenewFailed,
        onRenewTimeout: onRenewTimeout,
        onNotConfirmed: onNotConfirmed,
        hosts: hosts,
        tokenScope: tokenScope,
        setTokenReceiveTime: setTokenReceiveTime,
        renewMethodType: renewMethodType
      });
    }
  }]);

  return TokenProvider;
}();

export default TokenProvider;